import React, { useReducer } from "react";
import AuthContext from "./authContext";
import AuthReducer from "./authReducer";

import isTokenExpired from "../../helpers/jwtHelper";
import axios from "axios";
import {
  REGISTER_USER,
  LOGIN_USER,
  LOGIN_USER_ERROR,
  START_LOADING,
  STOP_LOADING,
  VERIFY_OTP_ERROR,
  VERIFY_OTP,
  REGISTER_USER_WITH_GOOGLE,
  REGISTER_USER_WITH_GOOGLE_ERROR,
  LOGOUT_USER,
  GET_USER,
  SET_TOKEN,
  POST_FAVOURITE_COIN,
  GET_USER_WITH_FAVOURITE_COINS,
  FETCH_WALLET_AMOUNT,
  EDIT_PROFILE,
  MODIFY_NAME_IN_VT,
  REGISTER_USER_ERROR,
  FETCH_BDETAILS,
  ADD_BDETAILS,
  WITHDRAW_MONEY,
  HANDLE_PAYMENT_ERROR,
  FETCH_PENDING_DETAILS,
  CLEAR_TRANSACTIONS,
  HIDE_SWAL,
  DELETE_BDETAILS,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_CURRENT_PASSWORD,
} from "../types";
import dotenv from "dotenv";
import { toast } from "react-toastify";
dotenv.config();
const getOTPDetailsFromLocalStorage = localStorage.getItem("userDetailsforOTP")
  ? JSON.parse(localStorage.getItem("userDetailsforOTP"))
  : null;
const getUserDetailsFromLocalStorage =
  localStorage.getItem("userData") &&
  typeof JSON.parse(localStorage.getItem("userData")) !== "undefined"
    ? JSON.parse(localStorage.getItem("userData"))
    : null;
const getTokenFromLocalStorage = localStorage.getItem("token")
  ? JSON.parse(localStorage.getItem("token"))
  : null;

const AuthState = ({ children }) => {
  const initialState = {
    loading: false,
    isAuthenticated: false,
    success: false,
    userData: getUserDetailsFromLocalStorage,
    authError: null,
    userDetailsForOTP: getOTPDetailsFromLocalStorage,
    message: null,
    token: getTokenFromLocalStorage,
    favouriteCoins: null,
    wallet: null,
    walletData: null,
    bDetails: [],
    paymentError: null,
    pendingDetails: null,
    withdrawSwal: false,
    favouriteLoading: false,
  };
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  const config = {
    headers: {
      "x-auth-token": state.token,
    },
  };
  const registerUser = async (formData) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      dispatch({ type: START_LOADING });
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/accounts/cr_acc`,
        formData,
        config
      );
      dispatch({ type: REGISTER_USER, payload: data });
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    dispatch({ type: STOP_LOADING });
  };

  const loginUser = async (formData) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    try {
      dispatch({ type: START_LOADING });
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/accounts/login`,
        formData,
        config
      );

      dispatch({ type: LOGIN_USER, payload: data });
      if (data.success) {
        getUser(1, data.data.token);
      }
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    dispatch({ type: STOP_LOADING });
  };
  const verifyOtp = async (formData) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (formData.aid === null) {
    }
    try {
      dispatch({ type: START_LOADING });
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/accounts/verify_email`,
        formData,
        config
      );
      dispatch({ type: VERIFY_OTP, payload: data });
      dispatch({ type: STOP_LOADING });
    } catch (err) {
      dispatch({
        type: VERIFY_OTP_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const registerUserWithGoogle = async () => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/accounts/auth/google/callback`
      );
      dispatch({ type: REGISTER_USER_WITH_GOOGLE, payload: data });
    } catch (err) {
      dispatch({
        type: REGISTER_USER_WITH_GOOGLE_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    dispatch({ type: STOP_LOADING });
  };
  const getUser = async (id = 1, token = state.token) => {
    if (token) {
      try {
        if (token && isTokenExpired(token)) {
          logoutUser();
        }
        id === 1 && dispatch({ type: START_LOADING });

        const config = {
          headers: {
            "x-auth-token": token,
          },
        };
        const { data } = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/users`,
          config
        );
        delete data.data.walletData;

        id === 2
          ? dispatch({ type: GET_USER_WITH_FAVOURITE_COINS, payload: data })
          : dispatch({ type: GET_USER, payload: data });
        id === 1 && dispatch({ type: STOP_LOADING });
      } catch (err) {
        dispatch({
          type: REGISTER_USER_WITH_GOOGLE_ERROR,
          payload:
            err.response && err.response.data.message
              ? err.response.data.message
              : err.message,
        });
      }
    }
    dispatch({ type: STOP_LOADING });
  };
  const addFavouriteCoin = async (id) => {
    if (
      (state.favouriteCoins && state.favouriteCoins.length < 20) ||
      state.favouriteCoins?.includes(id)
    ) {
      dispatch({ type: START_LOADING, Type: 2 });
      try {
        const config = {
          headers: {
            "x-auth-token": state.token,
          },
        };

        const { data } = await axios.put(
          `${process.env.REACT_APP_BASE_URL}/users/favourites/coin?id=${id}`,
          {},
          config
        );
        dispatch({ type: POST_FAVOURITE_COIN, payload: data });
        dispatch({ type: STOP_LOADING });
      } catch (err) {
        dispatch({
          type: LOGIN_USER_ERROR,
          payload:
            err.response && err.response.data.message
              ? err.response.data.message
              : err.message,
        });
      }
    } else {
      toast.error(
        "You have reached the limit, you cannot add more than 20 coins to watchlist!",
        { autoClose: 6000 }
      );
    }
  };
  const logoutUser = () => {
    dispatch({ type: LOGOUT_USER });
  };
  const setToken = (token) => {
    dispatch({ type: SET_TOKEN, payload: token });
  };
  const editProfile = async (formData) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/accounts/editProfile`,
        { ...formData, pid: state.userData.profile_data._id },
        config
      );
      dispatch({ type: EDIT_PROFILE, payload: data });
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const getAmountInWallet = async (pageNo = 1) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/payment/fetchWalletAmount?pid=${state.userData.profile_data._id}&pageNo=${pageNo}&limit=7`,
        config
      );
      dispatch({ type: FETCH_WALLET_AMOUNT, payload: data });
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const editPortfolioName = async (portName, portId) => {
    try {
      if (state.token && isTokenExpired(state.token)) {
        logoutUser();
      }

      const { data } = await axios.post(
        `${process.env.REACT_APP_VTRADING}/virtualTrading/editPortName`,
        {
          portId: portId,
          portName: portName,
        },
        config
      );

      //place order in vt
      dispatch({ type: MODIFY_NAME_IN_VT, payload: data });
    } catch (err) {
      dispatch({
        type: REGISTER_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const fireNotification = async (fcmToken) => {
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/fireNotification`,
      {
        fcmToken: fcmToken,
        title: "From Backend",
        bodyText:
          "this is notification is fired from API this is notification is fired from API Rushil asked me to do 2 lines",
        data: {},
      },
      { headers: { "x-auth-token": localStorage.token } }
    );
    console.log(data)
  };
  const fetchBDetails = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/payment/fetchBankDetails?pid=${state.userData.profile_data._id}`
      );
      dispatch({ type: FETCH_BDETAILS, payload: data.data });
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const addBDetails = async (formData) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/payment/addBankDetails`,
        { ...formData, pid: state.userData.profile_data._id },
        config
      );

      dispatch({ type: ADD_BDETAILS, payload: data });
      fetchBDetails();
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const withDrawMoney = async (formData) => {
    dispatch({ type: START_LOADING });
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/payment/withdrawWallet`,
        formData,
        config
      );

      dispatch({ type: WITHDRAW_MONEY, payload: data });
      getAmountInWallet();
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    dispatch({ type: STOP_LOADING });
  };
  const handlePaymentError = async (formData) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/payment/handlePaymentError`,
        formData,
        config
      );
      dispatch({ type: HANDLE_PAYMENT_ERROR, payload: data });
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const fetchPendingDetails = async (formData) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/payment/fetchPendingOrders?pid=${state.userData.profile_data._id}`,
        config
      );
      dispatch({ type: FETCH_PENDING_DETAILS, payload: data.data });
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const clearTransactions = () => {
    dispatch({ type: CLEAR_TRANSACTIONS });
  };

  const hideWithdrawSwal = () => {
    dispatch({ type: HIDE_SWAL });
  };
  const deleteBDetails = async (formData) => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/payment/deleteFundAccount`,
        formData,
        config
      );
      dispatch({ type: DELETE_BDETAILS, payload: data });

      fetchBDetails();
      return data;
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
  };
  const changePasswordRequest = async (formData) => {
    dispatch({ type: START_LOADING });
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/accounts/forgot`,
        formData,
        config
      );
      dispatch({ type: CHANGE_PASSWORD_REQUEST, payload: data });
      dispatch({ type: STOP_LOADING });

      return data;
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    dispatch({ type: STOP_LOADING });
  };
  const changePassword = async (formData) => {
    dispatch({ type: START_LOADING });
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/accounts/changeForgotPassword`,
        formData,
        config
      );
      dispatch({ type: CHANGE_PASSWORD, payload: data });
      dispatch({ type: STOP_LOADING });

      return data;
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    dispatch({ type: STOP_LOADING });
  };
  const changeCurrentPassword = async (formData) => {
    dispatch({ type: START_LOADING });
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/accounts/changePassword`,
        formData,
        config
      );
      dispatch({ type: CHANGE_CURRENT_PASSWORD, payload: data });
      dispatch({ type: STOP_LOADING });

      return data;
    } catch (err) {
      dispatch({
        type: LOGIN_USER_ERROR,
        payload:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      });
    }
    dispatch({ type: STOP_LOADING });
  };
  return (
    <AuthContext.Provider
      value={{
        fireNotification,
        walletData: state.walletData,
        registerUser,
        loginUser,
        getUser,
        userData: state.userData,
        loading: state.loading,
        authError: state.authError,
        success: state.success,
        isAuthenticated: state.isAuthenticated,
        userDetailsForOTP: state.userDetailsForOTP,
        verifyOtp,
        message: state.message,
        registerUserWithGoogle,
        token: state.token,
        logoutUser,
        setToken,
        addFavouriteCoin,
        favouriteCoins: state.favouriteCoins,
        wallet: state.wallet,
        bDetails: state.bDetails,
        getAmountInWallet,
        editProfile,
        editPortfolioName,
        fetchBDetails,
        addBDetails,
        withDrawMoney,
        handlePaymentError,
        paymentError: state.paymentError,
        pendingDetails: state.pendingDetails,
        fetchPendingDetails,
        clearTransactions,
        withdrawSwal: state.withdrawSwal,
        favouriteLoading: state.favouriteLoading,
        hideWithdrawSwal,
        deleteBDetails,
        changePasswordRequest,
        changePassword,
        changeCurrentPassword,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthState;
